import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=7ca163a2&scoped=true"
import script from "./complain.vue?vue&type=script&lang=js"
export * from "./complain.vue?vue&type=script&lang=js"
import style0 from "./complain.vue?vue&type=style&index=0&id=7ca163a2&prod&lang=css&scoped=true"
import style1 from "./complain.vue?vue&type=style&index=1&id=7ca163a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca163a2",
  null
  
)

export default component.exports